export const LOG_COLLECTION = 'MERCHANT_PRODUCTION';
export const ENABLE_LOGS = true;
